import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    // Fullscreen overlay (keeps sidebar + navbar visible underneath)
    <div className="fixed inset-0 flex items-center justify-center bg-white/30 backdrop-blur-md z-[999]">
      <div className="text-center bg-white/60 backdrop-blur-sm p-10 rounded-lg shadow-lg">
        <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
        <h2 className="text-2xl text-gray-600 mb-6">Page Not Found</h2>
        <Link
          to="/"
          className="px-6 py-2 bg-[#735AA7] text-white rounded hover:bg-[#8A7DB8] transition-colors"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
